import { ApiLinkEntity, ApiLinkRel } from 'config/constants';
import dayjs, { Dayjs } from "utils/dayjs";
import { IApiLink,  Guid  } from "@/types";
export interface IGetCalculationDetailsVersionDto {
    id: Guid
    userId: Guid
    date: string
    description: string
    comment?: string
    links?: IApiLink[]
}

export interface IPostCalculationDetailsVersion{
    reservationCartId?: Guid,
    reservationId?: Guid
    description: string
    comment?:string
}

export default class CalculationDetailsVersion {
    id: Guid
    userId: Guid
    date: Dayjs
    description: string
    comment?: string
    linkGetCalculationDetails?: IApiLink
    linkGetComments?: IApiLink

    userEmail?: string

    constructor(dto: IGetCalculationDetailsVersionDto) {

        this.id = dto.id
        this.userId = dto.userId
        this.date = dayjs(dto.date)
        this.description = dto.description
        this.comment = dto.comment

        this.linkGetCalculationDetails = dto.links?.find(lnk =>
            lnk.entity === ApiLinkEntity.calculationDetails
            && lnk.rel === ApiLinkRel.self
        )
        this.linkGetComments = dto.links?.find(lnk =>
            lnk.entity === ApiLinkEntity.calculationVersionComment
            && lnk.rel === ApiLinkRel.all
        )

    }

    provideUserEmail(userEmail:string){
        this.userEmail = userEmail
    }
}
